// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html,
body {
    overflow: hidden;
}

.webgl {
    position: fixed;
    top: 0;
    left: 0;
    outline: none;
}

.nav-menu {
    position: fixed;
    top: 2rem;
    right: 2rem;
    z-index: 1;
}

.nav-menu ul {
    list-style: none;
}

.nav-menu li {
    color: white;
    cursor: pointer;
    padding: 0.5rem 1rem;
    margin: 0.5rem 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    transition: background-color 0.3s;
}

.nav-menu li:hover {
    background: rgba(0, 0, 0, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n    overflow: hidden;\n}\n\n.webgl {\n    position: fixed;\n    top: 0;\n    left: 0;\n    outline: none;\n}\n\n.nav-menu {\n    position: fixed;\n    top: 2rem;\n    right: 2rem;\n    z-index: 1;\n}\n\n.nav-menu ul {\n    list-style: none;\n}\n\n.nav-menu li {\n    color: white;\n    cursor: pointer;\n    padding: 0.5rem 1rem;\n    margin: 0.5rem 0;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    transition: background-color 0.3s;\n}\n\n.nav-menu li:hover {\n    background: rgba(0, 0, 0, 0.8);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
